import { ElementRef, Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { ApplicationFormService } from '../application-form/application-form.service';

@Injectable({
   providedIn: 'root',
})
export class SlideCommonService {
   applicationNative: ElementRef | undefined;

   constructor(
      private afs: ApplicationFormService,
      private logger: LoggerService
   ) {}

   save(form: FormGroup | FormControl, currentSlide: string, formState: any, active: any) {
      if (form.valid) {
         console.log(currentSlide + ' is valid');

         if (currentSlide === 'applicant') {
            formState.progress.applicantComplete = true;
         } else if (currentSlide === 'joint') {
            formState.progress.jointApplicantComplete = true;
         } else if (currentSlide === 'residents') {
            formState.progress.residentsComplete = true;
         } else if (currentSlide === 'affordability') {
            formState.progress.affordabilityComplete = true;
         } else if (currentSlide === 'safeguarding') {
            formState.progress.safeguardingComplete = true;
         } else if (currentSlide === 'references') {
            formState.progress.referencesComplete = true;
         } else if (currentSlide === 'jointReferences') {
            formState.progress.jointReferencesComplete = true;
         } else if (currentSlide === 'terms') {
            formState.progress.termsComplete = true;
         }

         this.afs.setFormState(formState);
         this.afs.goForward(currentSlide);
         this.scroll(active.active);
      } else {
         if (currentSlide === 'applicant') {
            formState.progress.applicantComplete = false;
         } else if (currentSlide === 'joint') {
            formState.progress.jointApplicantComplete = false;
         } else if (currentSlide === 'references') {
            formState.progress.referencesComplete = false;
         } else if (currentSlide === 'residents') {
            formState.progress.residentsComplete = false;
         } else if (currentSlide === 'terms') {
            formState.progress.termsComplete = false;
         } else if (currentSlide === 'jointReferences') {
            formState.progress.jointReferencesComplete = false;
         } else if (currentSlide === 'affordability') {
            formState.progress.affordabilityComplete = false;
         } else if (currentSlide === 'safeguarding') {
            formState.progress.safeguardingComplete = false;
         }

         this.afs.setFormState(formState);
      }
   }

   //global
   scroll(active: string) {
      setTimeout(() => {
         const selector = `#${active}Slide`;

         const element = this.applicationNative?.nativeElement.querySelector(selector);

         if (typeof Breakpoint !== 'undefined') {
            if (Breakpoint.is('xs')) {
               // mobile scroll
               this.logger.info('Common > mobile scroll', Breakpoint.current());
            } else {
               // desktop scroll
               this.logger.info('Common > desktop scroll', Breakpoint.current());
            }
         }

         if (!element) {
            return this.logger.error('no target element found for ' + selector);
         }

         const yFromTop = element.getBoundingClientRect().top + window.scrollY;

         window.scroll({
            top: yFromTop,
            behavior: 'smooth',
         });
      }, 150);
   }

   //interslide, for error hrefs
   scrollToId(id: string, el: ElementRef, window: Window) {
      setTimeout(() => {
         const targetEl = el.nativeElement.querySelector(`#${id}`);

         if (!targetEl) {
            return this.logger.error('no target element found for id: ' + id);
         }

         const yFromTop = targetEl.getBoundingClientRect().top + window.scrollY;

         window.scroll({
            top: yFromTop,
            behavior: 'smooth',
         });
      }, 150);
   }

   setRef(el: ElementRef) {
      this.applicationNative = el;
   }

   errorSummary() {
      console.log('errorSummary');
   }
}
